"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderContent = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var LoaderContent = function (props) {
    var className = props.className, _a = props.loading, loading = _a === void 0 ? false : _a, children = props.children;
    return (react_1.default.createElement("div", { className: "" }, loading ? ( //
    react_1.default.createElement("div", { className: "p-4" },
        react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null))) : (react_1.default.createElement("div", { className: className }, children))));
};
exports.LoaderContent = LoaderContent;
